import attributeCodes, { getAttributeValue } from "./attributeCodes";

export enum gaOrderTypes {
  order,
  quick_order,
  big_car_order,
  re_order_single,
  re_order_multiple
}

export enum gaDiscountCampaignEventActions {
  create,
  remove
}

export function gaOrderedTripMapper(orderType: gaOrderTypes, internParams?, externParams?) {
  var gaParams = null

  switch(orderType) {
    case gaOrderTypes.order:
      return {
        pickup_fulladdress: internParams.pickupAddress.fullAddress,
        pickup_zipcode: internParams.pickupAddress.zipCode,
        destination_fulladdress: internParams.destinationAddress ? internParams.destinationAddress.fullAddress : "unknown",
        destination_zipcode: internParams.destinationAddress ? internParams.destinationAddress.zipCode : "unknown",
        amount: externParams.finalPrice ? externParams.finalPrice : "unknown", // Only sent for FIXED trips
        id: externParams.id,
        fixed_price: externParams.finalPrice != null,
        fixed_trip: externParams.tripType === 'FIXED',
        issuer_company: externParams.issuedByCompany,
        quick_order: false,
        ...gaMapAttributeParams(externParams.attributes as [any])
      }

    case gaOrderTypes.quick_order:
      gaParams = {
        pickup_fulladdress: externParams.pickupAddress ? externParams.pickupAddress.fullAddress : "unknown",
        pickup_zipcode: externParams.pickupAddress ? externParams.pickupAddress.zipCode : "unknown",
        destination_fulladdress: externParams.destinationAddress ? externParams.destinationAddress.fullAddress : "unknown",
        destination_zipcode: externParams.destinationAddress ? externParams.destinationAddress.zipCode : "unknown",
        amount: externParams.finalPrice ? externParams.finalPrice : "unknown", // Only sent for FIXED trips
        id: externParams.id,
        fixed_price: externParams.finalPrice != null,
        fixed_trip: false,
        issuer_company: externParams.issuedByCompany,
        quick_order: true,
        ...gaMapAttributeParams(externParams.attributes as [any])
      }
      break;

    case gaOrderTypes.big_car_order:
      // externParams = result.data[0]
      // internParams = order
      return {
        pickup_fulladdress: internParams.pickupAddress.fullAddress,
        pickup_zipcode: internParams.pickupAddress.zipCode,
        destination_fulladdress: internParams.destinationAddress ? internParams.destinationAddress.fullAddress : 'unknown',
        destination_zipcode: internParams.destinationAddress ? internParams.destinationAddress.zipCode : 'unknown',
        amount: externParams.finalPrice ? externParams.finalPrice : "unknown", // Only sent for FIXED trips
        id: externParams.id,
        fixed_price: externParams.finalPrice != null,
        fixed_trip: externParams.tripType === 'FIXED',
        issuer_company: externParams.issuedByCompany,
        quick_order: false,
        ...gaMapAttributeParams(internParams.attributes.concat(externParams.attributes) as [any])
      }

    case gaOrderTypes.re_order_single:
      // externParams = result.data
      // internParams = null
      return {
        pickup_fulladdress: externParams.pickupAddress ? externParams.pickupAddress.fullAddress : "unknown",
        pickup_zipcode: externParams.pickupAddress ? externParams.pickupAddress.zipCode : "unknown",
        destination_fulladdress: externParams.destinationAddress ? externParams.destinationAddress.fullAddress : "unknown",
        destination_zipcode: externParams.destinationAddress ? externParams.destinationAddress.zipCode : "unknown",
        amount: externParams.finalPrice ? externParams.finalPrice : "unknown", // Only sent for FIXED trips
        id: externParams.id,
        fixed_price: externParams.finalPrice != null,
        fixed_trip: externParams.tripType === 'FIXED',
        issuer_company: externParams.issuedByCompany,
        quick_order: false,
        ...gaMapAttributeParams(externParams.attributes as [any])
      }

    case gaOrderTypes.re_order_multiple:
      // externParams = orderResult (from result.data.forEach)
      // internParams = null
      return {
        pickup_fulladdress: externParams.pickupAddress ? externParams.pickupAddress.fullAddress : 'unknown',
        pickup_zipcode: externParams.pickupAddress ? externParams.pickupAddress.zipCode : 'unknown',
        destination_fulladdress: externParams.destinationAddress ? externParams.destinationAddress.fullAddress : 'unknown',
        destination_zipcode: externParams.destinationAddress ? externParams.destinationAddress.zipCode : 'unknown',
        amount: externParams.finalPrice ? externParams.finalPrice : "unknown",
        id: externParams.id,
        fixed_price: externParams.finalPrice != null,
        fixed_trip: externParams.tripType === 'FIXED',
        issuer_company: externParams.issuedByCompany,
        quick_order: false,
        ...gaMapAttributeParams(externParams.attributes as [any])
      }

  }
  return gaParams
}

export function gaCancelledTripMapper(internParams) {
  return {
    pickup_fulladdress: internParams.pickupAddress ? internParams.pickupAddress.fullAddress : "unknown",
    pickup_zipcode: internParams.pickupAddress ? internParams.pickupAddress.zipCode : "unknown",
    destination_fulladdress: internParams.destinationAddress ? internParams.destinationAddress.fullAddress : "unknown",
    destination_zipcode: internParams.destinationAddress ? internParams.destinationAddress.zipCode : "unknown",
    amount: internParams.finalPrice ? internParams.finalPrice : "unknown", // Only sent for FIXED trips
    id: internParams.id,
    fixed_price: internParams.finalPrice != null,
    fixed_trip: internParams.tripType === 'FIXED',
    issuer_company: internParams.issuedByCompany,
    ...gaMapAttributeParams(internParams.attributes as [any])
  }
}

export function gaDiscountCampaingMapper(actionType: gaDiscountCampaignEventActions, internParams, externParams?) {
  switch(actionType) {
    case gaDiscountCampaignEventActions.create:
      // externParams = result.data[0]
      // internParams = values
      return {
        discount_percentage: internParams.discount,
        id: externParams.id,
        campaign_name: internParams.name
      }

    case gaDiscountCampaignEventActions.remove:
      // externParams = null
      // internParams = discountCode
      return {
        discount_percentage: internParams.percentage,
        id: internParams.id,
        campaign_name: internParams.code
      }
  }
}

export function gaFixedTripMapper(values) {
  return {
    pickup_fulladdress: values.pickupAddress ? values.pickupAddress.fullAddress : 'unknown',
    pickup_zipcode: values.pickupAddress ? values.pickupAddress.zipCode : 'unknown',
    destination_fulladdress: values.destinationAddress ? values.destinationAddress.fullAddress : 'unknown',
    destination_zipcode: values.destinationAddress ? values.destinationAddress.zipCode : 'unknown',
    amount: values.price,
    title: values.title
  }
}

export function gaTaxibonMapper(id) {
  return {
    id: id
  }
}

export function gaUserMapper(state) {
  return {
    user_id: state.user.id,
    user_type: state.user.role
  }
}

export function gaUserParameterMapper(user_id, user_type) {
  return {
    user_id: user_id,
    user_type: user_type
  }
}

function gaMapAttributeParams(attributes) {
  return {
    electric_vehicle: attributes.find(attribute => attributeCodes.electric_vehicle_code === attribute.code) ? true : false,
    includes_animals: attributes.find(attribute => attributeCodes.includes_animals_codes.includes(attribute.code)) ? true : false,
    large_cab: attributes.find(attribute => attributeCodes.large_cab_codes.includes(attribute.code)) ? true : false,
    includes_bikes: attributes.find(attribute => attributeCodes.includes_bikes_codes.includes(attribute.code)) ? true : false,
    flex_driving: attributes.find(attribute => attributeCodes.flex_driving_codes.includes(attribute.code)) ? true : false,
    courier_service: attributes.find(attribute => attributeCodes.courier_service_code.includes(attribute.code)) ? true : false,
    station_car: attributes.find(attribute => attributeCodes.station_car_code.includes(attribute.code)) ? true : false,
    discount_percentage: getAttributeValue(attributes, attributeCodes.discount_percentage_codes),
    special_agreement: getAttributeValue(attributes, attributeCodes.special_agreement_codes),
    pickup_list: attributes.find(attribute => attributeCodes.pickup_list_code.includes(attribute.code)) ? true : false,
    eurobonus: attributes.find(attribute => attributeCodes.eurobonus_code.includes(attribute.code)) ? true : false,
  }
}